import Layout from "components/layout/Layout";
import BlogList from "components/layout/blog/BlogList";
import BlogPagination from "components/layout/blog/BlogPagination";
import { useEffect, useState } from "react";
import config from "../config";

export default function Blog() {
  const [blogs, setBlogs] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)

  // Fetch blog data
  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await fetch(
            `${config.endpoints.baseUrl}/api/posts/list?page=${currentPage}`
        )
        const result = await response.json()
        setBlogs(result?.data)
        setTotalPages(result?.meta?.last_page)
      } catch (error) {
        console.error("Error fetching blog data:", error)
      }
    }
    fetchBlogs()
  }, [currentPage])

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page)
    }
  }

  return (
    <Layout
      headerStyle={1}
      footerStyle={1}
      breadcrumbTitle={
        <>
          Blog
        </>
      }
    >
      <section className="blog-area pb-150">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="blog-tav-wrap">
                <div className="tab-content">
                  <div>
                    <div className="blog-item-wrap">
                      <div className="row justify-content-center">

                        <BlogList
                            blogs={blogs}
                        />
                      </div>

                      <BlogPagination
                          currentPage={currentPage}
                          totalPages={totalPages}
                          onPageChange={handlePageChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
